<template>
    <div class="content">
        <div class="reportTop">答题情况</div>
        <div class="reportCont flex">
            <div class="reportLeft">
                <div v-if="report.score >= 60" class="grade-box" :class="{ gradeBox: report.score > 60 }">
                    <div :class="{ color: report.score >= 60 }">{{report.score}}</div>
                    <div :class="{ color: report.score >= 60 }">考试成绩</div>
                </div>
                <div v-else class="grade-box1" :class="{ gradeBox1: report.score < 60 }">
                    <div :class="{ color: report.score < 60 }">{{report.score}}</div>
                    <div :class="{ color: report.score < 60 }">考试成绩</div>
                </div>


                <div class="pos">
                    <i class="el-icon-warning"></i>每次考试学分不累加，取最高值
                </div>
            </div>
            <div class="reportMid">
                <div class="circle"></div>
                <div class="reportItem">
                    <div>{{useTime}}</div>
                    <div>分钟</div>
                    <div>用时</div>
                </div>
                <div class="reportItem">
                    <div :class="{ color: report.score > 60 }">{{report.rate }}%</div>
                    <div>准确率</div>
                </div>
                <div class="reportItem">
                    <div :class="{ color: report.score > 60 }">{{report.score}}</div>
                    <div>分</div>
                </div>
                <div class="reportItem">
                    <div>{{report.exam_count}}</div>
                    <div>次</div>
                    <div>考试次数</div>
                </div>
            </div>
            <div class="reportRight">
                <div
                        v-if="report.rate >= 60"
                        class="pass-box"
                        :class="{ passBox: report.rate >= 60 }"
                >{{"通过"}}
                </div>
                <div
                        v-else
                        class="pass-box1"
                        :class="{ passBox1: report.rate < 60 }"
                >{{"失败"}}
                </div>

            </div>
        </div>
        <div class="reportBottom">
            <div class="btn" @click="goBack">返回</div>
            <div class="btn" @click="analysis()">查看解析</div>
            <!--<div class="btn" @click="analysis()">查看错题解析</div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "report",
        data() {
            return {
                report: "",
                useTime: 0,
                examDoId: undefined,
                examId: undefined
            };
        },
        mounted() {

            this.report = JSON.parse(this.$route.query.report);
            this.useTime = this.$route.query.userTime
            this.examId = this.$route.query.examId
        },
        methods: {
            analysis() {
                console.log(this.examId, "试卷ID")
                this.$router.push({
                    path: "/analysis",
                    query: {"examId": this.examId, "examDoId": this.report.examDoId}
                });
            },

            goBack() {
                this.$router.go(-1);
            },

        },
    };
</script>
<style lang="less" scoped>
    .color {
        color: #ff9702 !important;
    }

    .content {
        width: 1200px;
        margin: 0 auto;
    }

    .reportTop {
        margin-bottom: 35px;
        height: 299px;
        font-size: 18px;
        text-align: center;
        line-height: 280px;
        color: rgba(255, 255, 255, 0.6);
        background-image: url("../../assets/img/study/exam/bg_1_10.png");
        background-position-y: -30px;
        background-repeat: no-repeat;
    }

    .reportCont {
        color: #029aff;
        margin: 0 70px;
    }

    .reportLeft {
        position: relative;
        width: 210px;
        height: 190px;
        .grade-box {
            background-image: url("../../assets/img/study/exam/bg_1_11.png");
            margin-left: 10px;
            width: 190px;
            height: 190px;
            text-align: center;

            background-repeat: no-repeat;

            div {
                font-size: 18px;
            }
            div:first-child {
                padding-top: 25px;
                font-size: 70px;
                font-weight: bold;
            }
        }
        .gradeBox1 {
            background-image: url("../../assets/img/study/exam/bg_1_13.png");
            margin-left: 10px;
            width: 190px;
            height: 190px;
            text-align: center;

            background-repeat: no-repeat;

            div {
                font-size: 18px;
            }
            div:first-child {
                padding-top: 25px;
                font-size: 70px;
                font-weight: bold;
            }
        }
        .pos {
            position: absolute;
            bottom: -35px;
            left: 0;
            font-size: 12px;
            width: 210px;
            text-align: center;
            i {
                font-size: 15px;
                margin-right: 5px;
            }
        }
    }

    .reportRight {
        .pass-box {
            background-image: url("../../assets/img/study/exam/bg_1_12.png");
            background-repeat: no-repeat;

            width: 190px;
            height: 190px;
            line-height: 190px;
            text-align: center;
            color: #fff;
            font-size: 45px;
            font-family: PingFang SC;
            font-weight: 500;
        }
        .passBox1 {
            background-image: url("../../assets/img/study/exam/bg_1_14.png");
            background-repeat: no-repeat;
            width: 190px;
            height: 190px;
            line-height: 190px;
            text-align: center;
            color: #fff;
            font-size: 45px;
            font-family: PingFang SC;
            font-weight: 500;
        }
    }

    .reportMid {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        width: 380px;
        height: 252px;
        .circle {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #fff;
        }
        .reportItem {
            width: 50%;
            box-sizing: border-box;
            text-align: center;
            height: 126px;
            div {
                &:nth-child(1) {
                    font-size: 34px;
                    margin-top: 10px;
                }
                &:nth-child(2) {
                    font-size: 12px;
                    margin: 7px 0;
                }
                &:nth-child(3) {
                    font-size: 16px;
                }
            }
            &:nth-child(2) {
                border-right: 1px solid #029aff;
            }
            &:nth-child(3) {
                border-bottom: 1px solid #029aff;
            }
            &:nth-child(4) {
                border-top: 1px solid #029aff;
            }
            &:nth-child(5) {
                border-left: 1px solid #029aff;
            }
        }
    }

    .reportBottom {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        .btn {
            cursor: pointer;
            width: 160px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            border-radius: 10px;
            border: 1px solid #029aff;
            color: #029aff;
            &:first-child {
                margin-right: 100px;
            }
        }
        .btn:hover {
            background-color: #029aff;
            color: #fff;
        }
    }
</style>
